import { render } from "./or-admin-contacts.vue?vue&type=template&id=a7024d68&bindings={\"options\":\"props\",\"unsaved\":\"options\"}"
import script from "./or-admin-contacts.vue?vue&type=script&lang=js"
export * from "./or-admin-contacts.vue?vue&type=script&lang=js"
script.render = render

export default script